import dayjs from 'dayjs'
import { isValidIBAN } from 'ibantools'
import { isValidPhoneNumber } from 'react-phone-number-input'
import * as yup from 'yup'

type Messages = Record<string, string>

export const businessInformationValidationSchema = (messages: Messages) =>
  yup.object().shape({
    companyDetails: yup.object().shape({
      name: yup.string().required(messages.required),
      address: yup.object().shape({
        street: yup.string().required(messages.street),
        streetNr: yup.string().required(messages.required),
        postalCode: yup.string().required(messages.postalCode),
        city: yup.string().required(messages.city),
      }),
    }),
  })

export const contactDataValidationSchema = (messages: Messages) =>
  yup.object().shape({
    firstName: yup.string().required(messages.required),
    surname: yup.string().required(messages.required),
    phone: yup
      .string()
      .test('isValid', messages.phoneIncorrect, (val) =>
        isValidPhoneNumber(`+${val}`),
      ),
  })

export const paymentMethodValidationSchema = (messages: Messages) =>
  yup.object().shape({
    name: yup.string().required(messages.required),
    iban: yup
      .string()
      .required(messages.general)
      .test('is-valid-iban', messages.invalidIban, (value) => {
        if (!value) return false
        return isValidIBAN(value)
      })
      .test(
        'is-german-iban',
        messages.noneGermanIban,
        (value) => (value && value.startsWith('DE')) || false,
      ),
    sepa: yup.boolean().oneOf([true], messages.general),
  })

export const poaValidationSchema = (messages: Messages) =>
  yup.object().shape({
    fullname: yup.string().required(messages.general),
    birthdate: yup
      .number()
      .required(messages.general)
      .test(
        'olderThan18',
        messages.over18,
        (value) => dayjs().diff(dayjs(value), 'years') >= 18,
      )
      .typeError(messages.general),
    signature: yup.string().required(messages.general),
  })
